import React from 'react';
import RefreshButton from '../../widgets/Buttons/RefreshButton';
import ExportDropdown from '../../widgets/Dropdown/ExportDropdown';
import { useDataTable } from '../DataTable';
import AppliedFilterChips from './AppliedFilterChips';
import BaseSearchFilter from './filters/BaseSearchFilter';

interface DataTableControlsProps {
  showSortDropdown?: boolean;
}

const DataTableControls: React.FC<DataTableControlsProps> = () => {
  const { isExportable, exportableFormats, isRefreshable, isSearchable, actionComponent, filterComponents } =
    useDataTable();

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between flex-wrap gap-3">
        <div className="d-flex gap-3 w-100 w-md-auto">{!!isSearchable && <BaseSearchFilter />}</div>
        <div className="d-flex gap-3 flex-wrap">
          {filterComponents.map((component, index) => (
            <React.Fragment key={index}>{component}</React.Fragment>
          ))}
          {!!isExportable && (
            <div className="d-sm-flex">
              <ExportDropdown formats={exportableFormats} />
            </div>
          )}
          {!!isRefreshable && (
            <div className="d-sm-flex">
              <RefreshButton />
            </div>
          )}
          {actionComponent}
        </div>
      </div>
      <AppliedFilterChips />
    </div>
  );
};

export default DataTableControls;
